<template>
  <div class="container pl-4">
    <div id="device-count">
      <MetricsHeader :title="$t('dashboard.metrics.device_count')" :timespan="$t('dashboard.metrics.timespan.today')" />
      <VueApexCharts type="bar" :options="chartOptions" :series="data.series" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { IDeviceCount } from '@/store/modules/metrics/types';
import VueApexCharts from 'vue-apexcharts';
import Metrics from '@/mixins/Metrics';
import { onMounted, ref } from 'vue';
import useStore from '@/utils/store/common';
import MetricsHeader from './components/MetricsHeader.vue';

const store = useStore();

const chartOptions = ref({});
const data = ref({});

onMounted(async () => {
  const metrics: IDeviceCount = await store.dispatch('metrics/fetchDeviceCount');
  data.value = Metrics.transformDeviceCountData(metrics);
  chartOptions.value = Metrics.getBarChartOptions(metrics);
});
</script>
<style lang="scss" scoped>
@import './styles/device-count.scss';
</style>
